import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { IconLearning } from '~/ui/core/icons';

export const CourseTypeRow: FunctionComponent = () => {
    const translate = useTranslate();

    return (
        <div className="flex flex-wrap items-center gap-l text-sm">
            <span className="inline-flex items-center gap-xs text-orange-800">
                <IconLearning size={14} />
                {translate('pages.learning-opportunities.course-title')}
            </span>
        </div>
    );
};
